import Tone from 'tone';
import PolyParameter from "parameters/PolyParameter.js";

export default superclass => class extends superclass  {

    noiseSources = [];

    disposeNoise() {
        this.noiseSources.forEach(
            noiseSource => noiseSource.dispose());

        this.noiseLevelParameter.dispose();
        this.noiseSources = undefined;
    }

    setupNoiseParameters() {
        this.noiseLevelParameter = new PolyParameter(
            'Noise Level', this.noiseSources.map(x => x.volume),
            {
                documentation: "Controls the volume for the noise",
                min: 0,
                max: 1,
                defaultValue: 0,
            });
        this.registerParameter(this.noiseLevelParameter);
        this.refreshNoiseParameters();
    }

    refreshNoiseParameters() {
        if (this.noiseLevelParameter) {
            this.noiseLevelParameter.setAudioParams(this.noiseSources.map(x => x.volume));
            this.noiseSources.forEach(s => s.start());
        }
    }

    createAndAttachNoise() {
        let noise = this.newNoiseVoice();
        //let slotNumber = this.noiseSources.length;
        //for (let osc in this.outputNodeX.outputs) {
            //console.log("Connecting noise to osc=%s voiceNumber=%s", osc, slotNumber, noise);
            // noise.connect(this.outputNodeX.outputs[osc].oscillator._voices[slotNumber]._volume);

        //}
        this.noiseSources.push(noise);
        this.refreshNoiseParameters();
    }

    onPolyNoise(poly) {
        // 6
        if (poly < this.noiseSources.length) {
            // we need to delete noises
            let _poly = poly;
            while (poly > this.noiseSources.length) {
                this.noiseSources[poly-1].disconnect();
            }
            this.noiseSources = this.noiseSources.slice(0, _poly);
            return;
        }
        while (poly > this.noiseSources.length) {
            this.createAndAttachNoise();
        }
    }

    newNoiseVoice(type='pink') {
        let x = new Tone.Noise(type);
        x.volume.value = 0;
        return x;
    }
}
